import { RestServiceUtils } from '../utils/RestServiceUtils';

const emergencyAlertService = {
    getAllAlerts: (organizationId, params) => {
        const URL = `/ums/${organizationId}/alert`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    getAlertById: (organizationId, alertId, params) => {
        const URL = `/ums/${organizationId}/alert/${alertId}`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    createNewAlert: (organizationId, payload) => {
        const URL = `/ums/${organizationId}/alert`;
        return RestServiceUtils.HTTP_POST(URL, payload, {}, false);
    },

    updateAlert: (organizationId, alertId, payload) => {
        const URL = `/ums/${organizationId}/alert/${alertId}`;
        return RestServiceUtils.HTTP_PUT(URL, payload, {}, false);
    },

    deleteAlerts: (organizationId, payload) => {
        const URL = `/ums/${organizationId}/alert`;
        return RestServiceUtils.HTTP_DELETE(URL, payload);
    },

    getAllAlertTemplates: (organizationId) => {
        const URL = `/ums/${organizationId}/alert/templates`;
        return RestServiceUtils.HTTP_GET(URL);
    },

    getAllAlertLogs: (organizationId, params) => {
        const URL = `/ums/${organizationId}/alert/logs`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    getAllTagsAndCategories: (organizationId, placeId) => {
        const URL = `/ums/${organizationId}/${placeId}/tag`;
        return RestServiceUtils.HTTP_GET(URL);
    },

    regenerateApiKey: (organizationId, alertId) => {
        const URL = `/ums/${organizationId}/alert/${alertId}/regenerateKey`;
        return RestServiceUtils.HTTP_PUT(URL);
    }
};

export default emergencyAlertService;
